import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Box,
  Container,
  Grid,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { icons, images } from "../../assets";
import { allColors } from "../../constants";

const RangeSection = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const renderPoints = (labellll) => {
    return (
      <ListItem disablePadding sx={{ marginTop: { xs: "5px", sm: 0 } }}>
        <img
          src={icons.circleCheckIcon}
          alt={icons.circleCheckIcon}
          style={{
            width: "20px",
            height: "20px",
            margin: "0 10px 0 0",
          }}
        />
        <ListItemText
          primary={labellll}
          sx={{
            "& > .MuiListItemText-primary": {
              fontSize: { xs: "12px", sm: "15px" },
              color: allColors.jetBlack,
              fontFamily: "Raleway",
              fontWeight: "400",
            },
          }}
        />
      </ListItem>
    );
  };

  return (
    <div
      style={{
        backgroundImage: "linear-gradient(to top, #ffda7a, #ffffff)",
        padding: "10px 0 20px",
        position: "relative",
      }}
      id="about"
    >
      <Container
        sx={{
          maxWidth: "1400px !important",
          marginTop: "60px",
        }}
      >
        <Box sx={{ marginTop: "30px" }}>
          <Grid
            container
            spacing={2}
            flexDirection={{ xs: "column-reverse", sm: "row" }}
            alignItems={"center"}
          >
            <Grid item xs={12} md={8} textAlign={"left"}>
              <Stack pl={{ xs: 1.5, md: 8 }}>
                <Typography
                  sx={{
                    fontSize: { xs: "20px", md: "28px" },
                    textAlign: { xs: "center", md: "left" },
                    color: allColors.jetBlack,
                    fontWeight: "500",
                    fontFamily: "Raleway",
                    marginTop: "20px",
                  }}
                >
                  Elephant in the room?
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "35px", md: "44px" },
                    color: allColors.jetBlack,
                    fontWeight: "700",
                    fontFamily: "Raleway",
                    margin: { xs: "20px", sm: "0px 0 8px" },
                    lineHeight: { xs: "40px", sm: "48px" },
                    textAlign: { xs: "center", md: "left" },
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  No more mid-contract price rises.
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: "35px", md: "44px" },
                    color: allColors.jetBlack,
                    fontWeight: "700",
                    fontFamily: "Raleway",
                    margin: { xs: "20px", sm: "0px 0 8px" },
                    lineHeight: { xs: "40px", sm: "48px" },
                    textAlign: { xs: "center", md: "left" },
                    display: { xs: "block", sm: "none" },
                  }}
                >
                  No more <br /> mid-contract <br /> price rises.
                </Typography>
                <Typography
                  sx={{
                    fontSize: { sx: "13px", md: "17px" },
                    color: allColors.jetBlack,
                    fontFamily: "Raleway",
                    fontWeight: "400",
                    margin: "0px 0 22px",
                  }}
                >
                  Unlike other providers, with Trust Business the{" "}
                  <span style={{ fontWeight: "700" }}>price you agree</span>, is
                  the{" "}
                  <span style={{ fontWeight: "700" }}>price you’ll pay</span>{" "}
                  for the length of your contract.
                </Typography>

                {renderPoints("No mid-contract price rises")}
                {renderPoints(
                  "No penalty if you close your business or relocate"
                )}
                {renderPoints("Fix your price for up to 3 years")}
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              display={{ xs: "block", sm: "none" }}
              textAlign={"center"}
            >
              <Box>
                <img
                  src={images.elephantImg}
                  style={{
                    width: "70%",
                    height: "auto",
                    margin: "0 auto",
                  }}
                  alt={images.elephantImg}
                />
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: "30px", textAlign: "center" }}>
            <a href="#phone-only" style={{ textDecoration: "none" }}>
              <Typography
                sx={{
                  fontSize: { sx: "18px", sm: "20px", md: "20px" },
                  color: allColors.blueCrayola,
                  fontWeight: "500",
                }}
              >
                Browse the range
              </Typography>
              <ExpandMoreIcon
                sx={{
                  width: "60px",
                  height: { xs: "40px", sm: "50px" },
                  color: allColors.blueCrayola,
                }}
              />
            </a>
          </Box>
          <img
            src={images.elephantImg}
            style={{
              width: isSmallScreen ? "100%" : "35%",
              height: "auto,",
              margin: "0 auto",
              position: "absolute",
              right: 0,
              bottom: "-30px",
              display: isSmallScreen ? "none" : "block",
            }}
            alt={images.elephantImg}
          />
        </Box>
      </Container>
    </div>
  );
};

export default RangeSection;
